var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoshopLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_1_",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.333,
    height: 52,
    viewBox: "0 0 53.333 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Surfaces"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Photo_Surface"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_no_shadow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19126",
    "data-name": "Path 19126",
    d: "M9.444,0H43.889a9.437,9.437,0,0,1,9.444,9.444V42.556A9.437,9.437,0,0,1,43.889,52H9.444A9.437,9.437,0,0,1,0,42.556V9.444A9.437,9.437,0,0,1,9.444,0Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Outlined_Mnemonics_Logos",
    transform: "translate(11.909 13.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ps"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19127",
    "data-name": "Path 19127",
    d: "M54,82.861V59.88c0-.156.067-.246.223-.246.38,0,.737,0,1.251-.022.536-.022,1.094-.022,1.7-.045s1.251-.022,1.943-.045,1.362-.022,2.032-.022a13.132,13.132,0,0,1,4.6.692,7.975,7.975,0,0,1,2.993,1.831,7.111,7.111,0,0,1,1.63,2.546,8.548,8.548,0,0,1,.514,2.9,7.985,7.985,0,0,1-1.34,4.757,7.652,7.652,0,0,1-3.6,2.725,14.474,14.474,0,0,1-5.025.759c-.536,0-.893,0-1.117-.022s-.536-.022-.96-.022v7.169a.278.278,0,0,1-.246.313H54.268C54.089,83.151,54,83.062,54,82.861Zm4.869-18.917v7.5c.313.022.6.045.871.045h1.184a8.342,8.342,0,0,0,2.568-.4,3.841,3.841,0,0,0,1.831-1.184,3.451,3.451,0,0,0,.692-2.3,3.676,3.676,0,0,0-.514-1.988,3.239,3.239,0,0,0-1.563-1.273A6.554,6.554,0,0,0,61.3,63.9c-.581,0-1.094,0-1.519.022a5.114,5.114,0,0,0-.916.022Z",
    transform: "translate(-54 -59.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19128",
    "data-name": "Path 19128",
    d: "M151.837,89.347a7.9,7.9,0,0,0-2.144-.759,11.773,11.773,0,0,0-2.5-.29,4.5,4.5,0,0,0-1.34.156,1.147,1.147,0,0,0-.692.447,1.184,1.184,0,0,0-.179.6.993.993,0,0,0,.223.581,2.52,2.52,0,0,0,.759.6c.514.268,1.05.514,1.586.737a16.176,16.176,0,0,1,3.439,1.63,5.2,5.2,0,0,1,1.764,1.854,4.821,4.821,0,0,1,.514,2.3,5.2,5.2,0,0,1-.871,2.97,5.6,5.6,0,0,1-2.5,1.988,10.233,10.233,0,0,1-4.042.715,15.384,15.384,0,0,1-3.037-.29,9.009,9.009,0,0,1-2.278-.715.439.439,0,0,1-.246-.424V97.566a.243.243,0,0,1,.089-.2.17.17,0,0,1,.2.022,9.56,9.56,0,0,0,2.769,1.094,10.4,10.4,0,0,0,2.635.335,4.263,4.263,0,0,0,1.854-.313,1.038,1.038,0,0,0,.6-.938,1.183,1.183,0,0,0-.536-.893,9.472,9.472,0,0,0-2.189-1.05,13.665,13.665,0,0,1-3.171-1.608,5.783,5.783,0,0,1-1.7-1.9,4.792,4.792,0,0,1-.514-2.278,5.253,5.253,0,0,1,.759-2.7,5.505,5.505,0,0,1,2.345-2.055,8.66,8.66,0,0,1,3.953-.782,19.254,19.254,0,0,1,2.769.2,7.858,7.858,0,0,1,1.921.514.392.392,0,0,1,.223.2,1.121,1.121,0,0,1,.045.268v3.64a.275.275,0,0,1-.112.223A.6.6,0,0,1,151.837,89.347Z",
    transform: "translate(-121.016 -78.761)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoshopLogo);
export default __webpack_public_path__ + "static/media/photoshop-logo.9c258c555dde838b14e6ea8631e43283.svg";
export { ForwardRef as ReactComponent };